import { IJsonQuery } from '../../types/jsonQuery/jsonQuery';
import { ITag } from '../../types/tags';
import { containsJsonQuery } from '../jsonQuery/containsJsonQuery';

/**
 * Поиск тега в массиве тегов по jsonQuery
 * @param {ITag[]} tags - массив тегов
 * @param jsonQuery - jsonQuery для поиска
 * @returns {ITag | null}
 */
export const findTagByJsonQuery = (tags: ITag[], jsonQuery: IJsonQuery): ITag | null => {
  const candidate = tags.find(tag => containsJsonQuery(tag.jsonQuery, jsonQuery));

  return candidate || null;
};
